import { render, staticRenderFns } from "./MobilProducts.vue?vue&type=template&id=3e74c56d"
import script from "./MobilProducts.vue?vue&type=script&lang=js"
export * from "./MobilProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports